import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { CButton } from "@coreui/react";
import { formatCurrency } from "../../../utils/currency";
import { AutoPayDebitDetails } from "./AutoPayDebitDetails";
import { formatUTCDate } from "../../../utils/string";
import Badge from "../../../components/Badge";

interface PropsInterface {
  summary: any;
  isAutopayEnabled: boolean;
  payment?: any;
}

export const StatementSummaryComponent: React.FC<PropsInterface> = (props) => {
  const { summary, isAutopayEnabled } = props;
  const navigate = useNavigate();
  const TITLE = "Account Summary";


  if (!summary?.invoice) {
    return (
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">{TITLE}</h2>
          <div className="card-text">
            No statements available for this account at this time.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body">
        <h2 className="card-title">{TITLE}</h2>
        <div className="card-text">
          <ul className="list-group">
            <li className="list-group-item d-flex list-group-item-action justify-content-between align-items-center">
              <span className="font-weight-bold">Due Date</span>{" "}
              <span className="text-right">
                {formatUTCDate(summary.invoice.paymentDueDate)}
              </span>
            </li>
            <li
              className="list-group-item d-flex list-group-item-action justify-content-between align-items-center"
              style={{ gridGap: 10 }}
            >
              <span className="font-weight-bold">Statement Period</span>{" "}
              <span className="text-right">
                {formatUTCDate(summary.invoice.billingStartDate)} -{" "}
                {formatUTCDate(summary.invoice.billingEndDate)}
              </span>
            </li>
            <li className="list-group-item d-flex list-group-item-action justify-content-between align-items-center">
              <span className="font-weight-bold">Current Period Charges</span>{" "}
              <span className="text-right">
                {/* {formatCurrency(summary.invoiceAmount)} */}
                {formatCurrency(summary.latestPeriodChargeAccrual)}
              </span>
            </li>
            {summary.pastDueBalance > 0 && (
              <li className="list-group-item d-flex list-group-item-action justify-content-between align-items-center">
                <span className="font-weight-bold">Past Due Amount</span>{" "}
                <span className="text-right">
                  {formatCurrency(summary.pastDueBalance)}
                </span>
              </li>
            )}
            {summary.paymentStatus && (
              <li className="list-group-item d-flex list-group-item-action justify-content-between align-items-center">
                <span className="font-weight-bold">Payment Status</span>{" "}
                <span className="text-right">
                  <Badge status={summary.paymentStatus} />
                </span>
              </li>
            )}
            <li
              className={`list-group-item d-flex list-group-item-action justify-content-between ${
                isAutopayEnabled ? "align-items-start" : "align-items-center"
              }`}
              style={{ gridGap: 10 }}
            >
              <span className="font-weight-bold">AutoPay</span>
              <span className="text-right account-summary-autopay-value">
                {isAutopayEnabled ? (
                  <span>
                    Debit <AutoPayDebitDetails />.
                  </span>
                ) : (
                  <span>Off</span>
                )}
              </span>
            </li>
          </ul>
        </div>
        <p />

        <div className="d-flex justify-content-between">
          <Link to="/statement" state={{ link: summary.invoice.invoiceLink }}>
            <CButton>See Current Statement</CButton>
          </Link>
          {summary.invoice.remainingBalance > 0 && (
            <CButton
              color="primary"
              onClick={() => {
                navigate("/make-payment");
              }}
            >
              Make Payment
            </CButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatementSummaryComponent;
